















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  MicroEntryVerificationAccount,
  microEntryVerificationAccountStatusMap,
  MicroEntryVerificationAccountStatus
} from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class HsabMicroEntryVerificationAccountList extends Vue {

 isEditing = false;
 showConfirmModal = false;
 accountToDelete: MicroEntryVerificationAccount = null;

  @Prop()
  disabled: boolean;

  microEntryVerificationAccountStatusMap = microEntryVerificationAccountStatusMap;
  bankAccountStore = useBankAccountStore();
  themeStore = useThemeStore();

  get buttonsAreDisabled () {
    return this.isEditing || this.disabled;
  }
  get isResyncInProgress (): boolean {
    return !this.bankAccountStore.linkedAccountsLoaded;
  }
  onEditButtonClicked (isEditing: boolean) {
    this.isEditing = isEditing;
  }
  get allAccounts (): any[] {
    if (!this.bankAccountStore.microEntryVerificationAccounts) {
      return [];
    }
    return this.bankAccountStore.microEntryVerificationAccounts
      .map(item => ({...item, isEdit: false, isPending: item.verificationStatus === MicroEntryVerificationAccountStatus.Pending, name: item.accountName}));
  }
  onDeleteClicked (account: MicroEntryVerificationAccount) {
    this.bankAccountStore.deleteMicroEntryAccount(account);
  }
  deleteRowHandler (data) {
      this.accountToDelete = data.item;
      this.showConfirmModal = true;
  }
  onModalClose () {
      this.accountToDelete = null;
      this.showConfirmModal = false;
  }
  confirmDelete () {
    if (this.accountToDelete) {
      this.bankAccountStore.deleteMicroEntryAccount(this.accountToDelete);
    }
    this.accountToDelete = null;
    this.showConfirmModal = false;
  }
  verifyButtonTooltipText (status: MicroEntryVerificationAccountStatus) {
    if (status === MicroEntryVerificationAccountStatus.Pending) {
      return "Account transactions may take up to 3 days to occur, please check back later to verify them.";
    } else if (status === MicroEntryVerificationAccountStatus.ReadyForVerification) {
      return "Account transactions may take up to 3 days to be visible within your account, please have the transaction values available to verify.";
    }
    return "";
  }

  isVerifyButtonEnabled (status: MicroEntryVerificationAccountStatus) {
    return !this.disabled
      && status === MicroEntryVerificationAccountStatus.ReadyForVerification;
  }
  onVerifyClicked (finicityAccountId: string): any {
    this.bankAccountStore.retrieveAchVerifyAccountUrl({ window, accountId: finicityAccountId });
  }
  listFields = [
  {
    key: "accountName",
    thClass: "text-left",
    tdClass: "",
    label: "Account Name"
  },
  {
    key: "accountLast4",
    thClass: "text-left pl-1",
    tdClass: "pl-1",
    label: "Account Number"
  },
  {
    key: "accountStatus",
    label: "Status",
    thClass: "text-left",
    tdClass: "text-left"
  },
  {
    key: "delete",
    label: "",
    thClass: "",
    tdClass: "text-right"
  }
];
}
